<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="accounts"
                    sort-by="createdTimestamp"
                    sort-desc="true"
                    :loading="tableloading"
                    loading-text="Calling account data..."
                    :search="search"
                >
                    <template v-slot:top>
                        <v-row align="center">
                            <v-col cols="2">
                                <v-switch
                                    v-model="editmode"
                                    :label="`Edit Mode: ${editmode.toString()}`"
                                    class="pa-3"
                                    color="#CCAFA5"
                                ></v-switch>
                            </v-col>
                            <v-col cols="2">
                                <v-progress-circular
                                    indeterminate
                                    color="#CCAFA5"
                                    v-if="update"
                                ></v-progress-circular>
                            </v-col>
                            <v-col cols="8">
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Search"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.adoflag="{ item }">
                        <v-btn v-if="checkFlagging(item.id) == 1" icon color="#FB4570" @click="openADODialog(item)" small>
                            <v-icon>
                                mdi-flag
                            </v-icon>
                        </v-btn>
                        <v-btn icon v-else @click="openADODialog(item)" small>
                            <v-icon>
                                mdi-flag-outline
                            </v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:item.hrflag="{ item }" v-if="permissions.setHRflag">
                        <v-btn icon color="#FB4570" @click="openHRDialog(item)" small v-if="checkHRFlagging(item.id) == 1">
                            <v-icon>
                                mdi-flag-variant
                            </v-icon>
                        </v-btn>
                        <v-btn icon @click="openHRDialog(item)" small v-else>
                            <v-icon>
                                mdi-flag-variant-outline
                            </v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:item.active="{ item }">
                        <v-checkbox
                            v-model="item.active"
                            :disabled="!editmode"
                            color="#18A558"
                            @change="updateAccount(item.id, item.email, item.active)"
                            dense hide-details
                        ></v-checkbox>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon @click="viewInfo(item)">
                            mdi-eye
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialog" width="550" fullscreen persistent>
            <v-card elevation="0" v-if="callData">
                <v-toolbar color="#E4B4B4">
                    <v-toolbar-title>View As: {{ selectedAccount.firstname + " " + selectedAccount.lastname }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeView">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar>
                <ViewDetails :person="selectedAccount" />
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogADOflagging" width="550" persistent>
            <v-card elevation="0">
                <v-toolbar color="#FFAEBC" elevation="0">
                    <v-toolbar-title>ADO Flagging</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogADOflagging = false">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text><br />
                    ADO Flag will be {{ checkFlagging(selectedAccountforflagging.id) == 1 ? "unset" : "set" }} for the selected applicant: <br /> <b>{{ selectedAccountforflagging.firstname + " " + selectedAccountforflagging.lastname }}</b> (email: {{ selectedAccountforflagging.email }}) <br /><br />
                    Please ensure that the correct applicant is being {{ checkFlagging(selectedAccountforflagging.id) == 1 ? "unflagged" : "flagged" }}.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#FFAEBC" @click="setADOFlag" :loading="adoloading">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogHRflagging" width="650" persistent>
            <v-card elevation="0" v-if="dialogHRflagging">
                <v-toolbar color="#FFAEBC" elevation="0">
                    <v-toolbar-title>HR Flagging</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogHRflagging = false">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text><br />
                    HR Flag will be {{ checkHRFlagging(selectedAccountforHRflagging.id) == 1 ? 'unset' : 'set' }} for the selected applicant: <br /> <b>{{ selectedAccountforHRflagging.firstname + " " + selectedAccountforHRflagging.lastname }}</b> (email: {{ selectedAccountforHRflagging.email }}) <br /><br />
                    Comment: <br />
                    <v-textarea dense outlined v-model="hrflag.comment" hide-details></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#FFAEBC" @click="setHRFlag" :loading="hrflagloading">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import auth from "@/js/auth";
import ViewDetails from "./ViewDetails.vue"
export default {
    components: {
        ViewDetails
    },
    data(){
        return {
            permissions: {},
            host: location.hostname.toString(),
            tableloading: false,
            search: '',
            headers: [],
            accounts: [],
            selectedAccount: {},
            dialog: false,
            editmode: false,
            update: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            callData: false,
            flaggingList: [],
            dialogADOflagging: false,
            selectedAccountforflagging : {},
            dialogHRflagging: false,
            selectedAccountforHRflagging : {},
            adoloading: false,
            hrflag: {
                value: 0,
                comment: ''
            },
            hrflagloading: false
        }
    },
    methods: {
        getPermissions(){
            const that = this;
            let permission = auth.get_permissions();

            if(permission.hasOwnProperty("setADOflag")){
                if(permission.setADOflag == 1){
                    that.permissions["setADOflag"] = true;
                }else {
                    that.permissions["setADOflag"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["setADOflag"] = true;
            }else {
                that.permissions["setADOflag"] = false;
            }

            if(permission.hasOwnProperty("setHRflag")){
                if(permission.setHRflag == 1){
                    that.permissions["setHRflag"] = true;
                }else {
                    that.permissions["setHRflag"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["setHRflag"] = true;
            }else {
                that.permissions["setHRflag"] = false;
            }

            let tableheaders = [
                { text: 'ADO', value: 'adoflag' },
                { text: 'HR', value: 'hrflag' },
                { text: 'Email', align: 'start', value: 'email',},
                { text: 'First Name', value: 'firstname' },
                { text: 'Last Name', value: 'lastname' },
                { text: 'Active', value: 'active' },
                { text: 'Actions', value: 'actions', sortable: false },
            ]

            //Data table Header Settings
            if(that.permissions["setHRflag"] == false){
                that.headers = tableheaders.filter(v=> v.value != 'hrflag');
            }else {
                that.headers = tableheaders;
            }
        },
        getAccountList(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getaccountslist';
            that.tableloading = true;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    // Parse JSON response and check for authentication success
                    if (json.result.match(/^OK/i)) {
                        that.accounts = json.data;
                        that.flaggingList = json.flags;
                        that.setSnackbar("Calling accounts successful!", "#388E3C"); //green
                        that.tableloading = false;
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        checkFlagging(id){
            const that = this;
            let value = 0;

            that.flaggingList.forEach(element => {
                if(element.id == id && element.type == 'setADOflag'){
                   value = element.value;
                }
            });

            return value
        },
        checkHRFlagging(id){
            const that = this;
            let value = 0;

            that.flaggingList.forEach(element => {
                if(element.id == id && element.type == 'setHRflag'){
                   value = element.value;
                }
            });

            return value
        },
        updateAccount(id, email, active){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            that.update = true;
            const formData = new FormData();

            formData.append("mode", "setProfile");
            formData.append("data", JSON.stringify({"id": id, "active": active}));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        that.update = false;
                    }else {
                        that.setSnackbar("Profile update for "+email+" successful!", "#388E3C"); //green
                        that.update = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.update = false;
                })
            //End of API calling
        },
        openADODialog(item){
            const that = this;

            if(that.permissions.setADOflag){
                that.selectedAccountforflagging = item;
                that.dialogADOflagging = true;
            }
        },
        setADOFlag(){
            const that = this;
            that.adoloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            let value = 0;

            if(that.checkFlagging(that.selectedAccountforflagging.id) == 1){
                value = 0;
            }else {
                value = 1;
            }

            let flag = {
                type: "setADOflag",
                value : value,
                id : that.selectedAccountforflagging.id
            };

            const formData = new FormData();

            formData.append("mode", "setAdminData");
            formData.append("data", JSON.stringify(flag));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("ADO Flag updated for this applicant", "#388E3C"); //green
                        that.adoflag = true;
                    }

                    that.adoloading = false;
                    
                    that.dialogADOflagging = false;
                    that.getAccountList();

                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.adoloading = false;
                })
            //End of API calling
        },
        openHRDialog(item){
            const that = this;

            if(that.permissions.setHRflag){
                that.selectedAccountforHRflagging = item;

                if(typeof(that.flaggingList.find(v=>v.id == item.id && v.type == 'setHRflag')) != 'undefined'){
                    that.hrflag = {
                        value: that.flaggingList.find(v=>v.id == item.id && v.type == 'setHRflag').value,
                        comment: that.flaggingList.find(v=>v.id == item.id && v.type == 'setHRflag').comment
                    }
                }else {
                    that.hrflag = {
                        value: 0,
                        comment: ""
                    }
                }
                that.dialogHRflagging = true;
            }
        },
        setHRFlag(){
            const that = this;
            that.hrflagloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            let value = 0;

            if(that.checkHRFlagging(that.selectedAccountforHRflagging.id) == 1){
                value = 0;
            }else {
                value = 1;
            }

            let flag = {
                type: "setHRflag",
                value : value,
                comment: that.hrflag.comment,
                id : that.selectedAccountforHRflagging.id
            };

            const formData = new FormData();

            formData.append("mode", "setAdminData");
            formData.append("data", JSON.stringify(flag));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("HR Flag updated for this applicant", "#388E3C"); //green
                    }

                    that.hrflagloading = false;
                    
                    that.dialogHRflagging = false;
                    that.getAccountList();

                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.hrflagloading = false;
                })
            //End of API calling
        },
        viewInfo(item){
            const that= this;
            that.dialog = true;
            that.selectedAccount = item;

            let user = {
                "name": item.firstname+" "+item.lastname,
                "email" : item.email,
                "uid" : item.uid,
                "department": "applicant",
                "status": item.active
            };

            sessionStorage.setItem('cupeapp_aaa', JSON.stringify(user));

            that.callData = true;
        },
        closeView(){
            const that= this;
            
            that.callData = false;
            that.dialog = false;
            sessionStorage.removeItem('cupeapp_aaa');

        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getPermissions();
        that.getAccountList();
    }
}
</script>